import useAlchemystStoreForAi from '@/hooks/ai/client/useAlchemystStoreForAi';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton, Tab, Tabs } from '@mui/material';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { useState } from 'react';
import { inboxCommonStyles } from '../../../constants/themes';
import SelectEmailsToCheck from './SelectEmailsToCheck';
import SelectInboxesToCheck from './SelectInboxesToCheck';

export interface AddEmailModalProps {
  open: boolean;
  onClose: () => void;
}

function AddEmailModal({ open, onClose }: AddEmailModalProps) {
  const { selectedInboxEmails, emailList } = useAlchemystStoreForAi(
    (store) => ({
      selectedInboxEmails: store.inbox.selectedInboxEmails,
      emailList: store.inbox.emailsToCheck,
    })
  );
  const [modalTabIndex, setModalTabIndex] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setModalTabIndex(newValue);
  };

  // Enhanced modal styling - wider and better layout
  const enhancedModalBox = {
    ...inboxCommonStyles.modalBox,
    width: 600, // Made wider
    maxWidth: '90vw', // Responsive max width
    height: '70vh', // Set fixed height
    display: 'flex',
    flexDirection: 'column',
  };

  return (
    <Modal open={open} onClose={onClose} aria-labelledby="add-emails-modal">
      <Box sx={enhancedModalBox}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1, flexShrink: 0 }}>
          <Tabs value={modalTabIndex} onChange={handleTabChange}>
            <Tab label="Select Inbox Emails" />
            <Tab label="Add Emails" />
          </Tabs>
          <IconButton 
            onClick={onClose} 
            sx={{ p: 1 }}
            aria-label="Close modal"
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <Box sx={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
          {modalTabIndex === 0 && <SelectInboxesToCheck onClose={onClose} />}
          {modalTabIndex === 1 && <SelectEmailsToCheck onClose={onClose} />}
        </Box>
      </Box>
    </Modal>
  );
}

export default AddEmailModal;
